import {MenuItem, Typography, Box, Checkbox} from '@mui/material';
import React, {forwardRef, useId} from 'react';
import styles from '../../../styles/components/bulk-tagging/style.module.scss';
import {ITag} from '../../pages/field-management/custom-field/DraggableTag';
import { useTranslation } from 'react-i18next';

type TagSelectListItemProps = {
  itemData: ITag;
  isSelected: boolean;
  onItemClick: (data: ITag) => void;
  isLastItem?: boolean;
};

const TagSelectListItem = forwardRef<HTMLLIElement, TagSelectListItemProps>(
  ({itemData, isSelected, onItemClick, isLastItem}, ref) => {
    const displayValue = String(itemData.tagValue);
    const labelId = useId();
    const {t} = useTranslation();

    return (
      <MenuItem
        role="listItem"
        tabIndex={0}
        ref={ref}
        onClick={() => onItemClick(itemData)}
        aria-label={`${displayValue} ${isSelected ? t('common.aurCheckbox.checked') : t('common.aurCheckbox.unchecked')}`}
        className={` ${isSelected && 'aurAllSelectItemChecked'} custom-aur-select-item ${isLastItem ? 'no-border' : ''}`}
      >
        <Box>
          <Checkbox
            className={styles.aurSelectItemCheckBox}
            tabIndex={-1}
            aria-label={`${displayValue} ${isSelected ? t('common.aurCheckbox.checked') : t('common.aurCheckbox.unchecked')}`}
            inputProps={{
              tabIndex: -1,
              "aria-label": `${displayValue} ${isSelected ? t('common.aurCheckbox.checked') : t('common.aurCheckbox.unchecked')}`
            }}
            checked={isSelected}
            checkedIcon={
              <img
                src={'/assests/images/checked_checkbox.svg'}
                alt="Tag selected"
              />
            }
          />
        </Box>
        <Typography
          id={labelId}
          className={`typo-text body3_size ${styles.aurAllSelectLabel}`}
          title={displayValue}
        >
          {displayValue}
        </Typography>
      </MenuItem>
    );
  }
);

export default TagSelectListItem;
